type ArtifactUrlKind = "content" | "download"

interface ArtifactUrlParams {
  accountAlias: string
  threadId: string
  artifactId: string
}

export function buildArtifactUrl({ accountAlias, threadId, artifactId }: ArtifactUrlParams, kind: ArtifactUrlKind): string {
  return `/api/${encodeURIComponent(accountAlias)}/ai/chat/threads/${encodeURIComponent(threadId)}/artifacts/${encodeURIComponent(artifactId)}/${kind}`
}
